import { render } from "./LbrxCustomizePopup.vue?vue&type=template&id=687d0bc0&scoped=true"
import script from "./LbrxCustomizePopup.vue?vue&type=script&lang=js"
export * from "./LbrxCustomizePopup.vue?vue&type=script&lang=js"

import "./LbrxCustomizePopup.vue?vue&type=style&index=0&id=687d0bc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687d0bc0"]])

export default __exports__